//# sourceMappingURL=one_trust.mjs.map
/// <reference types="./one_trust.d.mts" />
import * as $json from "../../../../gleam_json/gleam/json.mjs";
import * as $decode from "../../../../gleam_stdlib/gleam/dynamic/decode.mjs";
import * as $int from "../../../../gleam_stdlib/gleam/int.mjs";
import * as $list from "../../../../gleam_stdlib/gleam/list.mjs";
import * as $option from "../../../../gleam_stdlib/gleam/option.mjs";
import { None, Some } from "../../../../gleam_stdlib/gleam/option.mjs";
import * as $order from "../../../../gleam_stdlib/gleam/order.mjs";
import * as $result from "../../../../gleam_stdlib/gleam/result.mjs";
import * as $string from "../../../../gleam_stdlib/gleam/string.mjs";
import { toList, Empty as $Empty, CustomType as $CustomType, isEqual } from "../../../gleam.mjs";

export class Composed extends $CustomType {}
export const AnswerType$Composed = () => new Composed();
export const AnswerType$isComposed = (value) => value instanceof Composed;

export class InputText extends $CustomType {}
export const AnswerType$InputText = () => new InputText();
export const AnswerType$isInputText = (value) => value instanceof InputText;

export class Button extends $CustomType {}
export const AnswerType$Button = () => new Button();
export const AnswerType$isButton = (value) => value instanceof Button;

export class MultiChoice extends $CustomType {}
export const AnswerType$MultiChoice = () => new MultiChoice();
export const AnswerType$isMultiChoice = (value) => value instanceof MultiChoice;

export class RichText extends $CustomType {}
export const AnswerType$RichText = () => new RichText();
export const AnswerType$isRichText = (value) => value instanceof RichText;

export class Unknown extends $CustomType {}
export const AnswerType$Unknown = () => new Unknown();
export const AnswerType$isUnknown = (value) => value instanceof Unknown;

export class Section extends $CustomType {
  constructor(section_name, section_id, questions) {
    super();
    this.section_name = section_name;
    this.section_id = section_id;
    this.questions = questions;
  }
}
export const Section$Section = (section_name, section_id, questions) =>
  new Section(section_name, section_id, questions);
export const Section$isSection = (value) => value instanceof Section;
export const Section$Section$section_name = (value) => value.section_name;
export const Section$Section$0 = (value) => value.section_name;
export const Section$Section$section_id = (value) => value.section_id;
export const Section$Section$1 = (value) => value.section_id;
export const Section$Section$questions = (value) => value.questions;
export const Section$Section$2 = (value) => value.questions;

export class Question extends $CustomType {
  constructor(question_id, question_text, question_display_number, answer_type, section_id, section_index, answer) {
    super();
    this.question_id = question_id;
    this.question_text = question_text;
    this.question_display_number = question_display_number;
    this.answer_type = answer_type;
    this.section_id = section_id;
    this.section_index = section_index;
    this.answer = answer;
  }
}
export const Question$Question = (question_id, question_text, question_display_number, answer_type, section_id, section_index, answer) =>
  new Question(question_id,
  question_text,
  question_display_number,
  answer_type,
  section_id,
  section_index,
  answer);
export const Question$isQuestion = (value) => value instanceof Question;
export const Question$Question$question_id = (value) => value.question_id;
export const Question$Question$0 = (value) => value.question_id;
export const Question$Question$question_text = (value) => value.question_text;
export const Question$Question$1 = (value) => value.question_text;
export const Question$Question$question_display_number = (value) =>
  value.question_display_number;
export const Question$Question$2 = (value) => value.question_display_number;
export const Question$Question$answer_type = (value) => value.answer_type;
export const Question$Question$3 = (value) => value.answer_type;
export const Question$Question$section_id = (value) => value.section_id;
export const Question$Question$4 = (value) => value.section_id;
export const Question$Question$section_index = (value) => value.section_index;
export const Question$Question$5 = (value) => value.section_index;
export const Question$Question$answer = (value) => value.answer;
export const Question$Question$6 = (value) => value.answer;

export class ComposedAnswer extends $CustomType {
  constructor(sub_answers) {
    super();
    this.sub_answers = sub_answers;
  }
}
export const Answer$ComposedAnswer = (sub_answers) =>
  new ComposedAnswer(sub_answers);
export const Answer$isComposedAnswer = (value) =>
  value instanceof ComposedAnswer;
export const Answer$ComposedAnswer$sub_answers = (value) => value.sub_answers;
export const Answer$ComposedAnswer$0 = (value) => value.sub_answers;

export class AnswerButton extends $CustomType {
  constructor(answer, button_options) {
    super();
    this.answer = answer;
    this.button_options = button_options;
  }
}
export const Answer$AnswerButton = (answer, button_options) =>
  new AnswerButton(answer, button_options);
export const Answer$isAnswerButton = (value) => value instanceof AnswerButton;
export const Answer$AnswerButton$answer = (value) => value.answer;
export const Answer$AnswerButton$0 = (value) => value.answer;
export const Answer$AnswerButton$button_options = (value) =>
  value.button_options;
export const Answer$AnswerButton$1 = (value) => value.button_options;

export class AnswerRichText extends $CustomType {
  constructor(answer) {
    super();
    this.answer = answer;
  }
}
export const Answer$AnswerRichText = (answer) => new AnswerRichText(answer);
export const Answer$isAnswerRichText = (value) =>
  value instanceof AnswerRichText;
export const Answer$AnswerRichText$answer = (value) => value.answer;
export const Answer$AnswerRichText$0 = (value) => value.answer;

export class AnswerInputText extends $CustomType {
  constructor(answer) {
    super();
    this.answer = answer;
  }
}
export const Answer$AnswerInputText = (answer) => new AnswerInputText(answer);
export const Answer$isAnswerInputText = (value) =>
  value instanceof AnswerInputText;
export const Answer$AnswerInputText$answer = (value) => value.answer;
export const Answer$AnswerInputText$0 = (value) => value.answer;

export class AnswerMultiChoices extends $CustomType {
  constructor(answer, multi_choice_options) {
    super();
    this.answer = answer;
    this.multi_choice_options = multi_choice_options;
  }
}
export const Answer$AnswerMultiChoices = (answer, multi_choice_options) =>
  new AnswerMultiChoices(answer, multi_choice_options);
export const Answer$isAnswerMultiChoices = (value) =>
  value instanceof AnswerMultiChoices;
export const Answer$AnswerMultiChoices$answer = (value) => value.answer;
export const Answer$AnswerMultiChoices$0 = (value) => value.answer;
export const Answer$AnswerMultiChoices$multi_choice_options = (value) =>
  value.multi_choice_options;
export const Answer$AnswerMultiChoices$1 = (value) =>
  value.multi_choice_options;

export class AnswerUnknown extends $CustomType {}
export const Answer$AnswerUnknown = () => new AnswerUnknown();
export const Answer$isAnswerUnknown = (value) => value instanceof AnswerUnknown;

export function map_answer_to_type(a) {
  if (a instanceof ComposedAnswer) {
    return new Composed();
  } else if (a instanceof AnswerButton) {
    return new Button();
  } else if (a instanceof AnswerRichText) {
    return new RichText();
  } else if (a instanceof AnswerInputText) {
    return new InputText();
  } else if (a instanceof AnswerMultiChoices) {
    return new MultiChoice();
  } else {
    return new Unknown();
  }
}

export function answer_type_to_string(answer_type) {
  if (answer_type instanceof Composed) {
    return "composed";
  } else if (answer_type instanceof InputText) {
    return "input_text";
  } else if (answer_type instanceof Button) {
    return "button";
  } else if (answer_type instanceof MultiChoice) {
    return "multichoice";
  } else if (answer_type instanceof RichText) {
    return "rich_text";
  } else {
    return "unknown";
  }
}

export function encode_answer(answer) {
  if (answer instanceof ComposedAnswer) {
    let sub_answers = answer.sub_answers;
    return $json.object(
      toList([["sub_answers", $json.array(sub_answers, encode_answer)]]),
    );
  } else if (answer instanceof AnswerButton) {
    return $json.object(
      toList([
        ["type", $json.string(answer_type_to_string(new Button()))],
        ["answer", $json.string(answer.answer)],
        ["button_options", $json.array(answer.button_options, $json.string)],
      ]),
    );
  } else if (answer instanceof AnswerRichText) {
    return $json.object(
      toList([
        ["type", $json.string(answer_type_to_string(new RichText()))],
        ["answer", $json.string(answer.answer)],
      ]),
    );
  } else if (answer instanceof AnswerInputText) {
    return $json.object(
      toList([
        ["type", $json.string(answer_type_to_string(new InputText()))],
        ["answer", $json.string(answer.answer)],
      ]),
    );
  } else if (answer instanceof AnswerMultiChoices) {
    return $json.object(
      toList([
        ["type", $json.string(answer_type_to_string(new MultiChoice()))],
        ["answer", $json.array(answer.answer, $json.string)],
        [
          "multi_choice_options",
          $json.array(answer.multi_choice_options, $json.string),
        ],
      ]),
    );
  } else {
    return $json.object(toList([]));
  }
}

export function encode_question(question) {
  return $json.object(
    toList([
      ["question_id", $json.string(question.question_id)],
      ["question_text", $json.string(question.question_text)],
      [
        "question_display_number",
        $json.string(question.question_display_number),
      ],
      [
        "answer_type",
        $json.string(
          (() => {
            let _pipe = question.answer_type;
            return answer_type_to_string(_pipe);
          })(),
        ),
      ],
      ["section_id", $json.string(question.section_id)],
      ["section_index", $json.int(question.section_index)],
      ["answer", encode_answer(question.answer)],
    ]),
  );
}

export function encode_section(section) {
  return $json.object(
    toList([
      ["section_name", $json.string(section.section_name)],
      ["section_id", $json.string(section.section_id)],
      ["questions", $json.array(section.questions, encode_question)],
    ]),
  );
}

export function answer_type_decoder() {
  return $decode.then$(
    $decode.string,
    (content) => {
      if (content === "input_text") {
        return $decode.success(new InputText());
      } else if (content === "button") {
        return $decode.success(new Button());
      } else if (content === "composed") {
        return $decode.success(new Composed());
      } else if (content === "multichoice") {
        return $decode.success(new MultiChoice());
      } else if (content === "rich_text") {
        return $decode.success(new RichText());
      } else if (content === "unknown") {
        return $decode.success(new Unknown());
      } else {
        return $decode.success(new Unknown());
      }
    },
  );
}

function maybe_read_type(a, next) {
  return $decode.optional_field(
    "type",
    new None(),
    $decode.then$(
      $decode.optional(answer_type_decoder()),
      (t) => {
        if (t instanceof Some) {
          let b = t[0];
          if (isEqual(a, b)) {
            return $decode.success(t);
          } else {
            return $decode.failure(new None(), "type");
          }
        } else {
          return $decode.success(t);
        }
      },
    ),
    (content) => { return next(content); },
  );
}

function answer_button_decoder() {
  return maybe_read_type(
    new Button(),
    (_) => {
      return $decode.field(
        "answer",
        $decode.string,
        (answer) => {
          return $decode.field(
            "button_options",
            $decode.list($decode.string),
            (button_options) => {
              return $decode.success(new AnswerButton(answer, button_options));
            },
          );
        },
      );
    },
  );
}

function answer_multichoices_decoder() {
  return maybe_read_type(
    new MultiChoice(),
    (_) => {
      return $decode.field(
        "answer",
        $decode.list($decode.string),
        (answer) => {
          return $decode.field(
            "multi_choice_options",
            $decode.list($decode.string),
            (multi_choice_options) => {
              return $decode.success(
                new AnswerMultiChoices(answer, multi_choice_options),
              );
            },
          );
        },
      );
    },
  );
}

function answer_rich_text_decoder() {
  return maybe_read_type(
    new RichText(),
    (_) => {
      return $decode.field(
        "answer",
        $decode.string,
        (answer) => { return $decode.success(new AnswerRichText(answer)); },
      );
    },
  );
}

function answer_input_text_decoder() {
  return maybe_read_type(
    new InputText(),
    (_) => {
      return $decode.field(
        "answer",
        $decode.string,
        (answer) => { return $decode.success(new AnswerInputText(answer)); },
      );
    },
  );
}

function answer_composed_decoder() {
  return $decode.field(
    "sub_answers",
    $decode.list(
      $decode.one_of(
        answer_button_decoder(),
        toList([
          answer_input_text_decoder(),
          answer_rich_text_decoder(),
          answer_multichoices_decoder(),
        ]),
      ),
    ),
    (sub_answers) => { return $decode.success(new ComposedAnswer(sub_answers)); },
  );
}

function answer_decoder(answer_type) {
  if (answer_type instanceof Composed) {
    return answer_composed_decoder();
  } else if (answer_type instanceof InputText) {
    return answer_input_text_decoder();
  } else if (answer_type instanceof Button) {
    return answer_button_decoder();
  } else if (answer_type instanceof MultiChoice) {
    return answer_multichoices_decoder();
  } else if (answer_type instanceof RichText) {
    return answer_rich_text_decoder();
  } else {
    return $decode.success(new AnswerUnknown());
  }
}

export function question_decoder() {
  return $decode.then$(
    $decode.at(toList(["answer_type"]), answer_type_decoder()),
    (answer_type) => {
      return $decode.field(
        "question_id",
        $decode.string,
        (question_id) => {
          return $decode.field(
            "question_text",
            $decode.string,
            (question_text) => {
              return $decode.field(
                "question_display_number",
                $decode.string,
                (question_display_number) => {
                  return $decode.field(
                    "section_id",
                    $decode.string,
                    (section_id) => {
                      return $decode.field(
                        "section_index",
                        $decode.int,
                        (section_index) => {
                          return $decode.field(
                            "answer",
                            answer_decoder(answer_type),
                            (answer) => {
                              return $decode.success(
                                new Question(
                                  question_id,
                                  question_text,
                                  question_display_number,
                                  answer_type,
                                  section_id,
                                  section_index,
                                  answer,
                                ),
                              );
                            },
                          );
                        },
                      );
                    },
                  );
                },
              );
            },
          );
        },
      );
    },
  );
}

export function section_decoder() {
  return $decode.field(
    "section_name",
    $decode.string,
    (section_name) => {
      return $decode.field(
        "section_id",
        $decode.string,
        (section_id) => {
          return $decode.field(
            "questions",
            $decode.list(question_decoder()),
            (questions) => {
              return $decode.success(
                new Section(section_name, section_id, questions),
              );
            },
          );
        },
      );
    },
  );
}

function get_indexes_from_display_number(dn) {
  let _pipe = dn;
  let _pipe$1 = $string.split(_pipe, ".");
  return $list.map(
    _pipe$1,
    (s) => {
      let _pipe$2 = $int.parse(s);
      return $result.unwrap(_pipe$2, 0);
    },
  );
}

export function sort_by_question_display_number(q1, q2) {
  let _block;
  let _pipe = q1.question_display_number;
  _block = get_indexes_from_display_number(_pipe);
  let qdn1 = _block;
  let _block$1;
  let _pipe$1 = q2.question_display_number;
  _block$1 = get_indexes_from_display_number(_pipe$1);
  let qdn2 = _block$1;
  if (qdn1 instanceof $Empty) {
    return new $order.Lt();
  } else if (qdn2 instanceof $Empty) {
    return new $order.Lt();
  } else {
    let $ = qdn1.tail;
    if ($ instanceof $Empty) {
      return new $order.Lt();
    } else {
      let $1 = qdn2.tail;
      if ($1 instanceof $Empty) {
        return new $order.Lt();
      } else {
        let $2 = $.tail;
        if ($2 instanceof $Empty) {
          let $3 = $1.tail;
          if ($3 instanceof $Empty) {
            let s1 = qdn1.head;
            let s2 = qdn2.head;
            if (s1 === s2) {
              let q1$1 = $.head;
              let q2$1 = $1.head;
              return $int.compare(q1$1, q2$1);
            } else {
              let s1 = qdn1.head;
              let s2 = qdn2.head;
              return $int.compare(s1, s2);
            }
          } else {
            return new $order.Lt();
          }
        } else {
          return new $order.Lt();
        }
      }
    }
  }
}
